import React from "react"
import types from "prop-types"
import ItemRow from "shared/ItemRow"
import UserInfo from "shared/UserInfo"
import { CircularIconButton } from "shared/buttons"

const GroupFormBuilderList = ({ formBuilderGroups = [], deleteCategoryAbility }) => {
  if (!formBuilderGroups) {
    return <div>No Form Builder Groups</div>
  }

  return (
    formBuilderGroups.map((formBuilder) => {
      const { abilityId, grantee: group } = formBuilder
      const { name: groupName, members: groupMembers } = group

      return (
        <ItemRow
          key={abilityId}
          collapsable
          itemRowHeaderContent={(
            <span>{groupName}</span>
          )}
          itemRowHeaderControls={(
            <CircularIconButton
              ariaLabel="revoke form builder privileges from group"
              icon="close"
              onClick={deleteCategoryAbility(abilityId)}
            />
          )}
          itemRowBody={(
            <>
              {
                groupMembers.map((member) => (
                  <ItemRow
                    key={member.id}
                    className="dark last:mb-0"
                    itemRowHeaderContent={<UserInfo user={member} />}
                  />
                ))
              }
            </>
          )}
        />
      )
    })
  )
}

GroupFormBuilderList.propTypes = {
  formBuilderGroups: types.arrayOf(types.object),
  deleteCategoryAbility: types.func.isRequired,
}

export default GroupFormBuilderList
